import { createAction } from "redux-actions";
import {
  CLEAN_AUTH,
  SET_AUTH_TOKEN,
  SET_AUTH_USER,
  GET_PROFILE,
} from "../../constants/index";
import { apiGet, apiPost, apiPut } from "../../api/index";
import {
  urlLogout,
  urlGetProfile,
  urlProviderLogin,
  urlAuthChangePass2,
  urlAuthChangePass,
  urlNewTemporalPass,
  urlUserSecured,
  urlSpeakersSecured,
} from "../../api/urls";

export const logoutUser = createAction(CLEAN_AUTH, (data) => data);

export const setAuthUser = createAction(SET_AUTH_USER, (data) => data);
export const setAuthToken = createAction(SET_AUTH_TOKEN, (data) => data);

/**
 * User Refresh token.
 */
export const getProfile = createAction(GET_PROFILE, () =>
  apiGet(urlGetProfile, undefined, undefined)()
);

/**
 * User Refresh token.
 */
export const userLogout = createAction(CLEAN_AUTH, (obj) =>
  apiGet(urlLogout, undefined, undefined)()
);

/**
 * Create company.
 */
export const loginExt = createAction("LOGIN_EXT", (obj) =>
  apiPost(urlProviderLogin, obj, undefined, true)()
);

/**
 * Get auth info profile (user loged).
 */
export const updatePassword = createAction("CHANGE_PASSWORD", (obj) =>
  apiPut(urlAuthChangePass2, obj, undefined, true)()
);

/**
 * Create a temporal password for a provider.
 */
export const generateNewPassword = createAction(
  "NEW_TEMPORAL_PASSWORD",
  (obj) => apiPut(urlNewTemporalPass, obj, undefined, true)()
);

const generateFilterQuery = (filters) => {
  // const sort = filters.sort;
  let filter = "?";
  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.uuid !== undefined) filter += "&uuid=" + filters.uuid;
    if (filters.idFinca !== undefined) filter += "&idFinca=" + filters.idFinca;

  }
  // if (sort) filter += "&sort=" + sort;
  return filter;
};

export const getAllUsers = createAction("GET_USERS", (filter, param) =>
  apiGet(urlUserSecured + generateFilterQuery(filter), param, false)()
);

export const createUser = createAction("REGISTER_USER", (formData) =>
  apiPost(urlUserSecured, formData, undefined, true)()
);

export const getUser = createAction("GET_USER", (param) =>
  apiGet(urlUserSecured, param, true)()
);

export const getAllSpeakers = createAction("GET_SPEAKERS", (filter, param) =>
  apiGet(urlSpeakersSecured + generateFilterQuery(filter), param, false)()
);
